import React, { useCallback, useContext } from 'react';
import get from 'lodash/get';
import set from 'lodash/set';

import FormContext from 'src/presentation/contexts/FormContext';
import { SelectOption } from './helpers/memoriesHelper';
import { StyledMemoryDropdown } from './RuleLayout';

type ComparatorElementProps = {
  attr: string;
  'data-aid'?: string;
  disabled: boolean;
  comparatorOptions?: SelectOption[];
  onChange: (props: unknown) => void;
};

const ComparatorElement = ({
  attr,
  'data-aid': dataAid,
  disabled,
  comparatorOptions,
  onChange,
}: ComparatorElementProps) => {
  const { workingState } = useContext(FormContext);
  const [value, setValue] = React.useState(get(workingState, attr));

  const handleChange = useCallback(
    (value: string) => {
      setValue(value);
      onChange({ currentState: set({}, attr, value) });
    },
    [attr, setValue, onChange]
  );

  return (
    <StyledMemoryDropdown
      attr={attr}
      data-aid={dataAid}
      disabled={disabled}
      fitOpenerWidth={false}
      onChange={handleChange}
      options={comparatorOptions}
      placeholder="Select Comparator"
      value={value}
    />
  );
};

export default ComparatorElement;
